import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { paramParsify } from "utils/queryParams";
import { useGetReportList } from "./service/ReportsService";
import { InputYearPickerComponent, Title } from "components";
import { downloadUrl } from "utils/linkDownload";
import storage from "services/storage";
import dayjs from "dayjs";

const ReportsPage = ({ setLayoutAction }) => {
  const location = useLocation();
  const companyIdLocalStorage = storage.getCompanyID();

  // render custom action in title layout
  useEffect(() => {
    const parsedQueryParams = paramParsify(location?.search);

    setLayoutAction(
      <InputYearPickerComponent
        value={parsedQueryParams?.year || "All time"}
        limitToFiveYears={true}        
      />,
    );

    return () => {
      setLayoutAction(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const { response } = useGetReportList({ id: companyIdLocalStorage });
  const reports = useMemo(
    () =>
      (response?.data?.reports ?? [])?.reduce((prevObj, currentValue) => {
        const year = currentValue?.period?.split(" ")?.[1];
        return {
          ...prevObj,
          [year]: !prevObj?.[year]
            ? [currentValue]
            : [...prevObj?.[year], currentValue],
        };
      }, {}),
    [response],
  );

  return (
    <div className='reports-page grid gap-4'>
      {Boolean(Object.keys(reports)?.length) ? (
        Object.keys(reports)
          ?.sort((a, b) => b - a)
          ?.map((title, idx) => (
            <div className='pb-10' key={`${title}-${idx}`}>
              <Title title={title} />
              <div className='grid grid-cols-3 gap-4 pt-5' spacing={2}>
                {reports?.[title]?.map((report, reportIdx) => (
                  <div
                    key={`${title}-${idx}-${reportIdx}`}
                    className='section !p-[14px]'
                  >
                    <div className='flex flex-row justify-between'>
                      <div className='flex flex-row gap-4'>
                        <img alt='report-icon' src='/images/report-icon.svg' />
                        <div className='flex flex-col gap-1'>
                          <span className='text-[14px] font-semibold'>{`Monthly Report - ${report?.period}`}</span>
                          <span className='text-[12px] text-[#5F737F]'>{`Uploaded on ${dayjs(
                            report?.uploaded_date,
                          ).format("MMM DD, YYYY")}`}</span>
                        </div>
                      </div>
                      <img
                        className='cursor-pointer'
                        alt='report-download-icon'
                        src='/images/report-download-icon.svg'
                        onClick={() => {
                          downloadUrl(report?.document_url);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
      ) : (
        <div className='mt-20 flex items-center justify-center'>
          <img
            alt='table-empty-icon'
            src='/images/report-empty.svg'
            className='m-auto'
          />
        </div>
      )}
    </div>
  );
};

export default ReportsPage;
